import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux'; 
import { userService } from '../../services/user.service';
import {
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Modal,
  Box,
  TextField,
  Button,
  Typography,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { ToggleOn, ToggleOff } from '@mui/icons-material'; 
import { boardService } from '../../services/board.service';
import { getTableroUsers, saveAssingTablero } from '../../store/grupo.actions';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  fontFamily: 'Figtree, sans-serif',
};

const tableContainerStyle = {
  marginTop: 2,
  maxHeight: 250,
  overflowY: 'auto',
};

const stickyHeaderStyle = {
  position: 'sticky',
  top: 0,
  backgroundColor: '#fff', // Color de fondo para el encabezado
  zIndex: 1, // Asegura que el encabezado esté por encima de otros elementos
};

function BoardModal({ open, onClose, boardToEdit, onSave }) {
  const [nombreTablero, setNombreTablero] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [color, setColor] = useState('#fc9d03');
  const [region, setRegion] = useState('');
  const [listuserstablero, setGettableroUsers] = useState([]); 
  const [user, setUser] = useState(userService.getLoggedinUser().data.data);
  
  const DataInfo = useSelector(storeState => storeState.infoModulo.infoM);
  const regionOptions = DataInfo?.regionOptions || [];
  const members = useSelector(storeState => storeState.userModule.users);

  const [MostrarTabla, setTabla] = useState(false);
  
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    if (boardToEdit) {
      setNombreTablero(boardToEdit.nombre_tablero || '');
      setDescripcion(boardToEdit.descripcion || '');
      setColor(boardToEdit.color || '#fc9d03');
      setRegion(boardToEdit.fk_region_id || '');
      EstadoModalUsers();
      setTabla(true);
    } else {
      setTabla(false);
      setNombreTablero('');
      setDescripcion('');
      setColor('#fc9d03');
      setRegion('');
      setGettableroUsers([]); 
    }
  }, [boardToEdit]);

  async function EstadoModalUsers() {
    try {
      const usuariosData = await getTableroUsers(boardToEdit.id_tablero);
      setGettableroUsers(usuariosData.usuarios); 
    } catch (err) {
      console.error('Error al obtener los datos de revisión:', err);
    }
  }

  const handleSave = async () => {
    const boardData = { nombre_tablero: nombreTablero, color: color, estado: 1, fk_region_id: region, descripcion: descripcion };
    if (boardToEdit) {
      boardData.id_tablero = boardToEdit.id_tablero;
      await boardService.UbdateBoard(boardData);
    } else {
      await boardService.SaveBoard(boardData, user.id_usuario);
    }
    onSave();
    onClose();
  };

  const handleToggleUser = (userId, boardId) => {
    const isActive = listuserstablero.includes(userId);
    const newUserList = isActive
      ? listuserstablero.filter(id => id !== userId)
      : [...listuserstablero, userId];

    setGettableroUsers(newUserList);

    const assingTablero = {
      fk_tablero_id: boardId,
      fk_usuario_id: userId,
      estado: isActive ? '0' : '1',
    };

    saveAssingTablero(assingTablero, !isActive);
  };

  const filteredMembers = members.filter(user =>
    `${user.nombre} ${user.apellido}`.toLowerCase().includes(searchTerm.toLowerCase())
  );

   // Filtrar usuarios por la región seleccionada
   const usersInSelectedRegion = members.filter(user => user.fk_region_id === region);

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <Typography variant="h6" component="h2" gutterBottom>
          {boardToEdit ? 'Actualizar Tablero' : 'Crear Nuevo Tablero'}
        </Typography>
        
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              label="Nombre del Tablero"
              fullWidth
              value={nombreTablero}
              onChange={(e) => setNombreTablero(e.target.value)}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="Descripción del Tablero"
              fullWidth
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
            />
          </Grid>
          
          <Grid item xs={6}>
            <TextField
              label="Color"
              type="color"
              fullWidth
              value={color}
              onChange={(e) => setColor(e.target.value)}
            />
          </Grid>
          
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel id="region-select-label">Región</InputLabel>
              <Select
                labelId="region-select-label"
                value={region}
                onChange={(e) => setRegion(e.target.value)}
                label="Región"
              >
                {regionOptions.map((region) => (
                  <MenuItem key={region.id_regioncde} value={region.id_regioncde}>
                    {region.nombre_region}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {MostrarTabla && (
          <>
              <Grid container spacing={2} alignItems="center">
        <Grid item xs={6}>
          <TextField
            label="Buscar Usuario"
            fullWidth
            margin="normal"
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ marginBottom: 1 }}
          />
        </Grid>

        <Grid item xs={6}>
          <Typography variant="body1" sx={{ marginLeft: 2 }}>
          Usuarios Asignados: {listuserstablero.length} / {members.length} 
          </Typography>
        </Grid>
      </Grid>
            <TableContainer component={Paper} sx={tableContainerStyle}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={stickyHeaderStyle}>Nombre</TableCell>
                    <TableCell sx={stickyHeaderStyle}>Unidad</TableCell>
                    <TableCell sx={stickyHeaderStyle}>Imagen</TableCell>
                    <TableCell sx={stickyHeaderStyle}>Región</TableCell>
                    <TableCell sx={stickyHeaderStyle}>Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredMembers.map((user, index) => (
                    <TableRow key={index}>
                      <TableCell>{user.nombre} {user.apellido}</TableCell>
                      <TableCell>{user.unidad}</TableCell>
                      <TableCell>
                        <img src={user.imgurl} alt={user.nombre} style={{ width: 30, height: 30, borderRadius: '50%' }} />
                      </TableCell>
                      <TableCell>{user.fk_region_id}</TableCell>
                      <TableCell>
                        <IconButton
                          color={listuserstablero.includes(user.id_usuario) ? 'primary' : 'default'}
                          size="small"
                          onClick={() => handleToggleUser(user.id_usuario, boardToEdit.id_tablero)}
                        >
                          {listuserstablero.includes(user.id_usuario) ? <ToggleOn /> : <ToggleOff />}
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2 }}>
          {/* <Button onClick={onClose} color="secondary" sx={{ marginRight: 1 }}>
            Cancelar
          </Button> */}
          <Button onClick={handleSave} variant="contained" color="primary">
            Guardar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default BoardModal;


